// 1. Määritellään globaali objekti HETI.
window.bulkImageLoader = {
	// loadImage: (Koodi pysyy ennallaan)
	loadImage: async function (targetElementId) {
		// ... (JSON-haku ja kuvan asetuslogiikka)
		const targetImageElement = document.getElementById(targetElementId);

		if (!targetImageElement || targetImageElement.classList.contains('images-loaded')) {
			return;
		}
		// ... (rest of the logic for handle, fetch, and image URL assignment)

		const productHandle = targetElementId.replace('variant-image-', '');
		if (!productHandle) {
			return;
		}

		try {
			const apiUrl = `/products/${productHandle}.js`;
			const response = await fetch(apiUrl);

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const productData = await response.json();
			let imageUrl = null;

			if (productData.featured_image) {
				// Käytetään suoraa URL-merkkijonoa, kuten halusit
				imageUrl = productData.featured_image;
			}

			if (imageUrl) {
				targetImageElement.src = imageUrl;
				targetImageElement.classList.remove('loading-variant-image');
				targetImageElement.classList.add('images-loaded');
			}
		} catch (error) {
			console.error(`Virhe tuotteen ${productHandle} haussa:`, error);
		}
	},

	processContent: function (container) {
		const loadingElements = container.querySelectorAll('.loading-variant-image');
		loadingElements.forEach(img => {
			if (!img.classList.contains('images-loaded')) {
				this.loadImage(img.id);
			}
		});
	}
};


// 2. DOMContentLoaded: Käsittelee staattisen latauksen ja asettaa Observerin vain tarvittaessa
document.addEventListener('DOMContentLoaded', () => {

	// --- LATAUS 1: YRITÄ KÄYNNISTÄÄ KAIKKI JO LUODUT KUVAT (Tuotesivu & Tuotelistat) ---
	// Tämä on kriittinen vaihe tuotesivulla, jossa modalia ei ole.
	window.bulkImageLoader.processContent(document);


	// --- LATAUS 2: ASETA OBSERVER VAIN JOS MODALI LÖYTYY (Tuotelistat) ---
	const bulkModalContainers = document.querySelectorAll('bulk-modal');
	if (bulkModalContainers.length === 0) {
		return; // Jatketaan suoritusta tuotesivulla, mutta lopetetaan tässä Observerin asettaminen.
	}

	const observerConfig = { childList: true, subtree: true };
	const observerCallback = (mutationsList, observer) => {
		// ... (MutationObserver-logiikka ennallaan)
		for (const mutation of mutationsList) {
			if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
				mutation.addedNodes.forEach(node => {
					if (node.nodeType === 1) {
						window.bulkImageLoader.processContent(node);
					}
				});
			}
		}
	};

	bulkModalContainers.forEach(container => {
		const observer = new MutationObserver(observerCallback);
		observer.observe(container, observerConfig);

		// Suoritetaan haku myös modalin olemassa olevaan sisältöön
		window.bulkImageLoader.processContent(container);
	});
});